module.exports = __webpack_public_path__ + "img/bit_withdraw_icon.eab1812e.svg";